import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

export const ClickStatsChart = ({ data, height = 200 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart data={(data || []).map((d) => ({ ...d, label: d.date.slice(5) }))}>
      <CartesianGrid strokeDasharray="3 3" stroke="#1F2937" vertical={false} />
      <XAxis dataKey="label" stroke="#6B7280" fontSize={10} />
      <YAxis stroke="#6B7280" fontSize={11} allowDecimals={false} width={30} />
      <Tooltip contentStyle={{ background: "#111827", border: "1px solid #1F2937", borderRadius: 12 }} cursor={{ fill: "#1F2937" }} />
      <Bar dataKey="clicks" fill="#06B6D4" radius={[4, 4, 0, 0]} name="Klik" />
    </BarChart>
  </ResponsiveContainer>
);

export const StatPill = ({ label, value, accent, testid }) => (
  <div className="bg-background rounded-lg p-3" data-testid={testid}>
    <p className="text-[11px] text-muted-foreground">{label}</p>
    <p className="font-display text-xl font-bold font-mono" style={{ color: accent }}>{value}</p>
  </div>
);
